"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
var FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
var styles_1 = require("@material-ui/core/styles");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var framework_1 = require("../../../../widgets/framework");
var styles_2 = __importDefault(require("./styles"));
var TermsOfUseUpdateModal = function (_a) {
    var show = _a.show, tosChecked = _a.tosChecked, onSubmitTos = _a.onSubmitTos, handleTosChecked = _a.handleTosChecked;
    var theme = (0, styles_1.useTheme)();
    var classes = (0, styles_2.default)(theme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var onNavigate = function (action) { return function () {
        var appNavigate = { action: action };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    }; };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(package_1.InformationDialog, { open: show, maxWidth: 'xs', hideXButton: true, hideButton: true, paperStyles: { maxWidth: '360px' } },
            react_1.default.createElement("div", { className: classes.mainDivAlt },
                react_1.default.createElement(Typography_1.default, { variant: "h6", component: "h1", color: 'textPrimary', gutterBottom: true, align: 'center', className: classes.bottomSpacing }, t('profile.termsOfUseUpdate.title')),
                react_1.default.createElement(Typography_1.default, { variant: "body1", component: "h2", color: 'textPrimary', gutterBottom: true, align: 'center', className: classes.bottomSpacing }, t('profile.termsOfUseUpdate.note')),
                react_1.default.createElement(FormControlLabel_1.default, { style: { pointerEvents: 'none', alignItems: 'flex-start' }, control: react_1.default.createElement(Checkbox_1.default, { checked: tosChecked, onChange: handleTosChecked, color: 'primary', style: {
                            padding: theme.spacing(0.5),
                            pointerEvents: 'auto',
                            marginLeft: theme.spacing(1)
                        } }), label: react_1.default.createElement(Typography_1.default, { variant: "subtitle1", component: "h3", style: {
                            pointerEvents: 'auto',
                            paddingTop: '4px',
                            display: 'flex',
                            flexWrap: 'wrap',
                            color: theme.palette.grey[700]
                        } },
                        t('profile.termsOfUseUpdate.text1'),
                        "\u00A0",
                        react_1.default.createElement(Button_1.default, { color: 'primary', role: 'link', variant: "text", onClick: onNavigate('TERMS_AND_CONDITIONS'), style: { padding: '0', minWidth: 'auto', textTransform: 'none' } }, t('profile.termsOfUseUpdate.text2')),
                        "\u00A0",
                        t('profile.termsOfUseUpdate.text3'),
                        "\u00A0",
                        react_1.default.createElement(Button_1.default, { color: 'primary', role: 'link', variant: "text", onClick: onNavigate('PRIVACY_POLICY'), style: { padding: '0', minWidth: 'auto', textTransform: 'none' } }, t('profile.termsOfUseUpdate.text4'))) }),
                react_1.default.createElement("div", { className: classes.buttonContainer },
                    react_1.default.createElement(Button_1.default, { className: classes.buttonStyle, size: "large", disabled: !tosChecked, variant: "contained", color: "primary", onClick: onSubmitTos }, t('profile.termsOfUseUpdate.submit')))))));
};
exports.default = TermsOfUseUpdateModal;
//# sourceMappingURL=TermsOfUseUpdateModal.js.map